const feedbackFormEl = document.querySelector('#feedbackForm');

if (feedbackFormEl) {
    const happinessRadioEls = feedbackFormEl.querySelectorAll('.js-happiness-radio');
    const totalSteps = parseInt(feedbackFormEl.getAttribute('data-total-steps'));

    const submitData = (noMessageParam = false, onSuccess) => {
       let serializedData = $('#feedbackForm').serialize();

       if (noMessageParam) {
           serializedData = serializedData.split('&').filter(param => !param.startsWith('feedbackMessage=')).join('&');
       }

        $.ajax({
            type: 'POST',
            url: '/ajax/feedback-form/',
            data: serializedData,
            success: function(response) {
                console.log('Form submitted successfully:', response);
                onSuccess();
            },
            error: function(xhr, status, error) {
                console.error('Error:', error);
            }
          });
    }

    const goToStep = (stepContainerEl, targetStep) => {
        const nextContainerEl = feedbackFormEl.querySelector(`[data-step="${targetStep}"]`);
        stepContainerEl.setAttribute('hidden', '');
        nextContainerEl.removeAttribute('hidden');

        // scroll to page top
        window.scroll(0, feedbackFormEl.getBoundingClientRect().top + window.scrollY - 126);
    };

    const handleRadioChange = (target) => {
        const stepContainerEl = target.closest('.step');
        let stepNumber = parseInt(stepContainerEl.getAttribute('data-step'));
        const nextStepNumber = parseInt(target.getAttribute('data-next-step'));

        if (stepNumber > totalSteps) stepNumber = totalSteps;

        if (nextStepNumber < totalSteps) {
            goToStep(stepContainerEl, nextStepNumber);
            return;
        }

        if (nextStepNumber === totalSteps) {
            submitData(true, () => {
                goToStep(stepContainerEl, nextStepNumber);
            });
        }
    }

    for (const happinessRadioEl of happinessRadioEls) {
        happinessRadioEl.addEventListener('change', function(event) {
            const target = event.currentTarget;
            handleRadioChange(target);
        });
    }

    $('.js-feedback-form-validate').each(function(index, element){
		var _form = $(element);

		_form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div',
			submitHandler: function (form, event) {
                event.preventDefault();
                event.stopPropagation();

                var el = _form.find('.submit-button');
                el.attr('disabled', true);
                el.html('Submitting...');

                submitData(false, () => {
                    const stepContainerEl = el.closest('.step')[0];
                    goToStep(stepContainerEl, 4);
                });
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids()) {
                    return;
                }
            },
		});
	});

}